import {Routes, RouterModule} from "@angular/router";
import {ModuleWithProviders} from "@angular/core";
import {PagesComponent} from "./pages/pages.component";
import {FrontendComponent} from "./frontend.component";
import {WelcomeComponent} from "./welcome/welcome.component";
import {StyleguideComponent} from "./styleguide/styleguide.component";
import {LoginComponent} from "./login/login.component";
import {SignupComponent} from "./signup/signup.component";
import {SearchComponent} from "./search/search.component";
import {ProductComponent} from "./product/product.component";
import {ProductSearchComponent} from "./product/search.component";
import {IngredientSearchComponent} from "./ingredient/search.component";
import {FrontendGuard} from "./frontend.guard";
import {AnalyseComponent} from "./analyse/analyse.component";
import {AnalyseResultComponent} from "./analyse/result.component";

const frontendRoutes: Routes = [
    {
        path: '',
        component: FrontendComponent,
        children: [
            {
                path: '',
                component: WelcomeComponent
            },
            {
                path: 'styleguide',
                component: StyleguideComponent,
                canActivate: [FrontendGuard]
            },
            {
                path: 'login',
                component: LoginComponent
            },
            {
                path: 'signup',
                component: SignupComponent
            },
            {
                path: 'search/:query',
                component: SearchComponent,
                //canActivate: [FrontendGuard]
            },
            {
                path: 'search/:query/:slug',
                component: SearchComponent,
                //canActivate: [FrontendGuard]
            },
            {
                path: 'product/:id/:slug',
                component: ProductComponent,
                //canActivate: [FrontendGuard]
            },
            {
                path: 'product/:query',
                redirectTo: '/products/:query',
                //canActivate: [FrontendGuard]
            },
            {
                path: 'products/:query',
                component: ProductSearchComponent,
                //canActivate: [FrontendGuard]
            },
            {
                path: 'zoek-ingredienten',
                component: IngredientSearchComponent,
                //canActivate: [FrontendGuard]
            },
            {
                path: 'huidanalyse/resultaat',
                component: AnalyseResultComponent,
                //canActivate: [FrontendGuard]
            },
            {
                path: 'huidanalyse/:section',
                component: AnalyseComponent,
                //canActivate: [FrontendGuard]
            },
            {
                path: 'huidanalyse',
                redirectTo: '/huidanalyse/reset',
                //canActivate: [FrontendGuard]
            },
            // Show the 404 page for any routes that don't exist.
            {
                path: '**',
                component: PagesComponent
            }
        ]
    }
];

export const frontendRouting: ModuleWithProviders = RouterModule.forChild(frontendRoutes);


// WEBPACK FOOTER //
// D:/Documents/FTP/derma/dermabase.nl_backup/src/app/frontend/frontend.routing.ts